import { BasePureComponent } from "./BaseComponent";
import * as React from "react";
import * as Compat from "../Compat";
import * as Glob from "../Globale";
import { NavLink } from "react-router-dom";
import { Trad } from "./Trad";

export class ProfileComponent extends BasePureComponent {
    public render() {
        let Sessione = Glob.GetSessione();
        let AdminAbilitazione: string = "hidden";

        let URLUtente: string = "";
        if (Sessione != undefined && Sessione.ID_Utente != undefined) {
            URLUtente = "/Utente/" + Sessione.ID_Utente;
        }

        if (Glob.AzioneAbilitata("Admin", Glob.Lettura)) {
            AdminAbilitazione = "";
        }
        const avatar = Sessione != undefined && Sessione.Immagine !== "" ? Sessione.Immagine : "uomo";

        return <div className="kt-header__topbar">
            <div className="header__topbar-wrapper">
                <ul className="kt-topbar__nav kt-nav kt-nav--inline">
                    {Sessione != undefined &&
                        <li className="dropdown dropdown-inline dropdown-large " kt-dropdown-toggle="click"
                            aria-expanded="true">
                            <a href="#" data-toggle="dropdown" aria-expanded="true"
                                className="kt-nav__link kt-dropdown__toggle">
                                <span className="kt-topbar__userpic topbar__userpic">
                                    <img
                                        src={Compat.ES6_String_startWith(Sessione.Immagine, 'http') ? Sessione.Immagine : "/cdn/users/" + avatar}
                                        className="kt-img-rounded kt--marginless kt--img-centered"
                                        alt="" />
                                </span>
                                <span
                                    className="kt-topbar__username hidden">{Sessione.Login}</span>
                            </a>
                            <div
                                className="dropdown-menu dropdown-menu-right dropdown-menu-anim">
                                <span
                                    className="kt-dropdown__arrow kt-dropdown__arrow--right kt-dropdown__arrow--adjust"></span>
                                <div className="kt-dropdown__inner">
                                    <div
                                        className="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x"
                                        style={{ backgroundImage: 'url(/images/user_profile_bg.jpg)' }}>
                                        <div className="kt-card-user kt-card-user--skin-dark">
                                            <div className="kt-user-card__avatar">
                                                <img
                                                    src={Compat.ES6_String_startWith(Sessione.Immagine, 'http') ? Sessione.Immagine : "/cdn/users/" + avatar}
                                                    className="kt-img-rounded kt--marginless"
                                                    alt="" />
                                            </div>
                                            <div className="kt-user-card__name">
                                                <span
                                                    className="kt-card-user__name kt--font-weight-500">{Sessione.Nome + ' ' + Sessione.Cognome}</span>
                                                <a href="#" onClick={(e) => {
                                                    e.preventDefault()
                                                }}
                                                    className="kt-card-user__email kt--font-weight-300 kt-link">{Glob.GetSessione().Email}</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="kt-dropdown__body">
                                        <div className="kt-dropdown__content">
                                            <ul className="kt-nav kt-nav--skin-light">
                                                <li className="kt-nav__section kt--hide">
                                                    <span
                                                        className="kt-nav__section-text">Section</span>
                                                </li>
                                                <li className="kt-nav__item">
                                                    <NavLink to={URLUtente}
                                                        className="kt-nav__link">
                                                        <i className="kt-nav__link-icon flaticon-avatar"></i>
                                                        <span className="kt-nav__link-title">
                                                            <span
                                                                className="kt-nav__link-wrap">
                                                                <span
                                                                    className="kt-nav__link-text">{Trad.Trad("Profilo utente")}</span>
                                                            </span>
                                                        </span>
                                                    </NavLink>
                                                </li>
                                                <li className="kt-nav__item">
                                                    <NavLink to="/File/Manuale.pdf"
                                                        className="kt-nav__link"
                                                        target="_blank">
                                                        <i className="kt-nav__link-icon flaticon-list-1"></i>
                                                        <span
                                                            className="kt-nav__link-text">{Trad.Trad("Manuale utente")}</span>
                                                    </NavLink>
                                                </li>
                                                <li className="kt-nav__item hidden">
                                                    <NavLink
                                                        to={"/api/Supporto?URL=" + encodeURIComponent(location.href) + "&Sessione=" + Glob.GetSessione().Sessione}
                                                        className="kt-nav__link">
                                                        <i className="kt-nav__link-icon flaticon-share"></i>
                                                        <span
                                                            className="kt-nav__link-text">{Trad.Trad("InviaSchermo")}</span>
                                                    </NavLink>
                                                </li>
                                                <li className="kt-nav__item">
                                                    <a href="https://projects.techs.srl/projects/myar-ticket"
                                                        target="_blank" className="kt-nav__link">
                                                        <i className="kt-nav__link-icon flaticon-lifebuoy"></i>
                                                        <span
                                                            className="kt-nav__link-text">{Trad.Trad("Supporto")}</span>
                                                    </a>
                                                </li>
                                                <li className="kt-nav__separator kt-nav__separator--fit">
                                                </li>
                                                <li className="kt-nav__item">
                                                    <a href="/logout"
                                                        className="btn btn--pill btn-secondary kt-btn kt-btn--custom kt-btn--label-brand kt-btn--bolder">Logout</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    }
                    <li className={"dropdown dropdown-inline dropdown-large " + AdminAbilitazione}
                        kt-dropdown-toggle="click" aria-expanded="true">
                        <a data-toggle="dropdown" aria-expanded="true" href="#"
                            className="kt-nav__link kt-dropdown__toggle">
                            <span
                                className="kt-nav__link-badge kt-badge kt-badge--dot kt-badge--info hidden"></span>
                            <span className="kt-nav__link-icon"><i
                                className="fa fa-cog"></i></span>
                        </a>
                        <div
                            className="dropdown-menu dropdown-menu-right dropdown-menu-anim">
                            <span
                                className="kt-dropdown__arrow kt-dropdown__arrow--right kt-dropdown__arrow--adjust">
                            </span>
                            <div className="kt-dropdown__inner">
                                <div
                                    className="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x"
                                    style={{ backgroundImage: 'url(/images/quick_actions_bgNew.jpg)' }}>
                                    <div className="kt-card-user margin-auto kt-card-user--skin-dark">
                                        <div className="kt-user-card__name text-center">
                                            <span
                                                className="kt-dropdown__header-title TextCenter">{Trad.Trad("Menu amministrativo")}</span>
                                            <span
                                                className="dropdown-item-text">{Trad.Trad("Sezioni")}</span>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="kt-dropdown__body kt-dropdown__body--paddingless">
                                    <div className="kt-dropdown__content">
                                        <div className="data" data-scrollable="false"
                                            data-max-height="380"
                                            data-mobile-max-height="200">
                                            <div
                                                className="kt-grid-nav kt-nav-grid--skin-light">
                                                <div className="kt-grid-nav__row">
                                                    <NavLink to="/Utente"
                                                        className="kt-grid-nav__item">
                                                        <i className="kt-grid-nav__icon fa fa-user"></i>
                                                        <span
                                                            className="kt-grid-nav__desc">{Trad.Trad("Gestione utenti")}</span>
                                                    </NavLink>
                                                    <NavLink to="/Prodotti"
                                                        className="kt-grid-nav__item hidden">
                                                        <i className="kt-grid-nav__icon flaticon-open-box"></i>
                                                        <span
                                                            className="kt-grid-nav__desc">{Trad.Trad("Gestione prodotti")}</span>
                                                    </NavLink>
                                                </div>
                                                <div className="kt-nav-grid__row hidden">
                                                    <NavLink to="/TabelleSistema"
                                                        className="kt-grid-nav__item">
                                                        <i className="kt-grid-nav__icon flaticon-list-1"></i>
                                                        <span
                                                            className="kt-grid-nav__desc">{Trad.Trad("Gestione tabelle di sistema")}</span>
                                                    </NavLink>
                                                    <NavLink to="/News"
                                                        className="kt-nav-grid__item">
                                                        <i className="kt-grid-nav__icon flaticon-chat-1"></i>
                                                        <span
                                                            className="kt-grid-nav__desc">{Trad.Trad("Gestione news")}</span>
                                                    </NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li className="dropdown dropdown-inline dropdown-large " kt-dropdown-toggle="click"
                        aria-expanded="true" title="Email us!">
                        <a href="mailto:info@techs.srl" className="kt-nav__link kt-dropdown__toggle">
                            <span className="kt-nav__link-icon"><i
                                className="fa fa-envelope"></i></span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    }
}




// WEBPACK FOOTER //
// ./src/components/ProfileComponent.tsx